export default "__VITE_ASSET__D5mq5Wrn__"